import { cardProviders } from '../screens/Card/constants';

export const CUSTODY_PROVIDERS = {
  CONNECT_FINANCIAL: 'connect_financial',
};

export const CONNECT_FINANCIAL_CUSTODY_COIN = 'usdc';

export const isConnectFinancialCustodyCountry = (supportedCountries, iso3166alpha3) =>
  supportedCountries?.find((country) => country.iso3166alpha3 === iso3166alpha3)
    ?.default_custody_provider === CUSTODY_PROVIDERS.CONNECT_FINANCIAL;

export const shouldAskTinCountry = (supportedCountries, iso3166alpha3, isUS) =>
  !isUS &&
  supportedCountries?.find((country) => country.iso3166alpha3 === iso3166alpha3)
    ?.default_card_provider === cardProviders.CONNECT_FINANCIAL;

export const shouldAskStateRegion = (supportedCountries, iso3166alpha3, isUS) =>
  !isUS && isConnectFinancialCustodyCountry(supportedCountries, iso3166alpha3);

export const isConnectFinancialCustodyUser = (user) =>
  user?.custody_provider === CUSTODY_PROVIDERS.CONNECT_FINANCIAL;

export const selectConnectFinancialCustodyWallets = (wallets) =>
  wallets?.filter((wallet) => wallet.coin?.toLowerCase() === CONNECT_FINANCIAL_CUSTODY_COIN);
